import { AddFineComponent } from "./components/fines/add-fine/add-fine.component";
import { Routes } from "@angular/router";
import { RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { FinancialSettingsComponent } from "./components/financial-settings/financial-settings.component";
import { FinesComponent } from "./components/fines/fines.component";

const routes: Routes = [
  {
    path: "",
    component: FinancialSettingsComponent,
    children: [
      {
        path: "fines",
        pathMatch: "exact",
        component: FinesComponent,
      },
      {
        path: "fines/add",
        component: AddFineComponent,
      },
      {
        path: "fines/edit/:id",
        component: AddFineComponent,
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FinancialSettingsRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/financial/financial-settings/financial-settings-routing.module.ts